import { getUserID } from "./getLocalStorage";
import httpService from "./httpService";

export const getNewMessagesApi = () => {
  return httpService.get(`ask-a-nurse/new-chats?user_id=${getUserID()}`);
};
